import { useContext, useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import AuthContext from "../../context/auth/AuthContext";

const useTenantQuerySession = () => {
  const queryClient = useQueryClient();
  const { tenant, token, user } = useContext(AuthContext);
  const sessionKey = [
    tenant?.code ?? "",
    user?.id ?? user?.username ?? "",
    token ?? "",
  ].join(":");
  const previousSessionKey = useRef(sessionKey);

  useEffect(() => {
    if (previousSessionKey.current !== sessionKey) {
      queryClient.clear();
      previousSessionKey.current = sessionKey;
    }
  }, [queryClient, sessionKey]);
};

export default useTenantQuerySession;
